export enum CORP_TYPE {
  STAFF_AUG = "STAFF_AUG",
  APPRENTICESHIP = "APPRENTICESHIP",
}

export const CORPORATION = {
  STAFF_AUG: { corpId: "8yy144", swimlane: "33" },
  APPRENTICESHIP: { corpId: "7xjpg0", swimlane: "32" },
};
